import { ErrorHandler, inject, Injectable, Injector } from '@angular/core';

import { ModalService } from './common/components/modal/modal.service';
import { CodoxError } from './common/enums/enums';

@Injectable({ providedIn: 'root' })
export class AppErrorHandler implements ErrorHandler {
    private modalService: ModalService;
    private modalShown = false;

    constructor() {
        const injector = inject(Injector);

        setTimeout(() => (this.modalService = injector.get(ModalService)));
    }
    handleError(error) {
        try {
            console.warn(error);
            const isCodoxError = error?.stack?.includes(CodoxError.STACK_PART_DOMAIN);
            const message: string = error.originalStack && error.originalStack.toString ? error.originalStack.toString() : error.toString();
            const firstLine = message.split('\n')[0];
            let trace = null;

            // suppress codoxwave duplicate key errors
            const codoxDuplicateKeyError = message.includes(CodoxError.MESSAGE_DUPLICATE_KEY) && message.includes(CodoxError.MESSAGE_DUPLICATION_CODE);
            if (codoxDuplicateKeyError) {
                console.error('codoxDuplicateKeyError', message);
                return;
            }
            if (isCodoxError) {
                if (error?.type === CodoxError.TYPE_UNVALID_SUBSCRIPTION_API_KEY) {
                    console.warn('codoxSubscriptionNotFound', message);
                    return;
                }
                if (error?.message.includes(CodoxError.EDITOR_NOT_FOUND)) {
                    console.warn(error?.message);
                    return;
                }
            }

            if (window['sourceMappedStackTrace'] && window['sourceMappedStackTrace']?.mapStackTrace) {
                window['sourceMappedStackTrace'].mapStackTrace(error.toString(), mappedStack => {
                    trace = null;
                    if (mappedStack) {
                        trace = mappedStack.join('\n');
                    }
                    if (!trace) {
                        trace = error.toString();
                    }
                    if (this.modalService && !this.modalShown) {
                        this.modalShown = true;
                        this.modalService.openServiceFatalErrorModal(
                            {
                                title: 'Error',
                                message: firstLine,
                                detailedMessage: trace,
                            },
                            true
                        );
                    }
                });
            } else {
                trace = this.getStackTrace(error);
                if (!trace) {
                    trace = error.toString();
                }
                // let modalShown = false;
                if (this.modalService && !this.modalShown) {
                    this.modalShown = true;
                    this.modalService.openServiceFatalErrorModal(
                        {
                            title: 'Error',
                            message: firstLine,
                            detailedMessage: trace,
                        },
                        true
                    );
                }
            }
        } catch (err) {
            console.warn(err);
        }
    }

    getStackTrace(error) {
        try {
            (Error as any).captureStackTrace(error);
            return error.stack;
        } catch (_err) {
            return null;
        }
    }
}
